import { ImageCropTypes } from '@/components/misc/media/image-cropper/constants';

const useCropOptions = ({ mediaServerUrl }) => {
  const getCropOptions = (cropOptions, files) => {
    if (!cropOptions) {
      return [];
    }

    if (!mediaServerUrl) {
      throw new Error('mediaServerUrl cannot be empty.');
    }

    if (!files) {
      throw new Error('files cannot be empty.');
    }

    const options = [];
    files.forEach(file => {
      // TODO #16854 process for COPY_FROM_SOURCE option
      const fileOptions = cropOptions.map(cropOption => ({
        cropTypeId: cropOption.cropTypeId,
        name: cropOption.name,
        file: file.title,
        src: `${mediaServerUrl}${file.path}`,
        isFreeRatio: cropOption.cropTypeId === ImageCropTypes.FREE_RATIO,
        width: cropOption.width,
        height: cropOption.height,
      }));

      options.push(...fileOptions);
    });

    return options;
  };

  return {
    getCropOptions,
  };
};

export default useCropOptions;
